"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const $ = require("jquery");
const React = require("react");
const styled_components_1 = require("styled-components");
const Buttons_1 = require("components/styled/Buttons");
const Colors_1 = require("components/styled/Colors");
const Fonts_1 = require("components/styled/Fonts");
const Input_1 = require("components/styled/Input");
const ScreenSizes_1 = require("components/styled/ScreenSizes");
const Text_1 = require("components/styled/Text");
const Wrapper = styled_components_1.default.div `
  margin-bottom: 30px;
  width: 100%;

  ${ScreenSizes_1.TABLET_PORTRAIT} {
    margin-bottom: 0;
  }
`;
const Form = styled_components_1.default.form `
  ${ScreenSizes_1.TABLET_PORTRAIT} {
    margin-right: 20px;
  }

  ${ScreenSizes_1.TABLET_PORTRAIT} {
    margin-right: 0;
  }
`;
const Label = styled_components_1.default(Text_1.SectionText) `
  color: ${Colors_1.MAKO};
  font-size: 16px;
  font-family: ${Fonts_1.WalsheimFontStack};
  font-weight: 500;
  letter-spacing: 0;
  line-height: 16px;
  margin-bottom: 24px;
  text-align: center;

  ${ScreenSizes_1.TABLET_PORTRAIT} {
    text-align: left;
  }
`;
const FormElements = styled_components_1.default.div `
  ${ScreenSizes_1.TABLET_PORTRAIT} {
    border: 1px solid ${Colors_1.NEVADA};
    border-radius: 100px;
    display: flex;
    margin-bottom: 16px;
    max-width: 456px;
    width: 100%;
  }
`;
const Link = styled_components_1.default.a `
  color: ${Colors_1.BONDI};
  text-decoration: none;
`;
const Disclosure = styled_components_1.default(Text_1.SectionText) `
  color: ${Colors_1.MAKO};
  font-size: 13px;
  font-family: ${Fonts_1.SpaceMonoFontStack};
  letter-spacing: 0;
  text-align: center;

  ${ScreenSizes_1.TABLET_PORTRAIT} {
    text-align: left;
  }
`;
const Thanks = styled_components_1.default(Text_1.SectionText) `
  display: none;
  text-align: center;

  ${ScreenSizes_1.TABLET_PORTRAIT} {
    text-align: left;
  }
`;
class SignupForm extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            loading: false
        };
    }
    componentDidMount() {
        const submitWithAjax = () => {
            document.addEventListener('submit', e => {
                e.preventDefault();
                const form = $('#subscribe-form');
                this.setState({ loading: true });
                $.ajax({
                    url: form.attr('action'),
                    data: form.serialize(),
                    dataType: 'jsonp'
                }).always(() => {
                    this.setState({ loading: false });
                    $('#thanks').show();
                    $('.hide-after-submit').each(function () {
                        $(this).hide();
                    });
                });
            });
        };
        submitWithAjax();
    }
    render() {
        return (React.createElement("div", null,
            React.createElement(Label, null, "Stay up to date"),
            React.createElement(Wrapper, null,
                React.createElement(Form, { id: "subscribe-form", action: "//stellar.us9.list-manage.com/subscribe/post?u=c001d97369b7a10d224c23867&id=563f658d41&SIGNUP=homepage", method: "post", name: "mc-embedded-subscribe-form", target: "_blank", className: "hide-after-submit" },
                    React.createElement(FormElements, null,
                        React.createElement(Input_1.Input, { name: "EMAIL", type: "email", placeholder: "Email address", required: true }),
                        this.state.loading && (React.createElement(Buttons_1.BtnFooter, { disabled: true }, "Submitting...")),
                        !this.state.loading && React.createElement(Buttons_1.BtnFooter, null, "Sign Up")),
                    React.createElement(Disclosure, null,
                        "We handle your email address",
                        ' ',
                        React.createElement(Link, { target: "_blank", href: "https://www.stellar.org/privacy-policy/" }, "with care"),
                        ".")),
                React.createElement(Thanks, { id: "thanks" }, "Thanks! Check your email to confirm your subscription."))));
    }
}
exports.SignupForm = SignupForm;



// WEBPACK FOOTER //
// ./src/components/styled/SignupForm.tsx